export default __webpack_public_path__ + "static/media/operating.e87eaed2.svg";